import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", ...l }, /* @__PURE__ */ e.createElement("path", { fill: "#4D4E58", fillRule: "evenodd", d: "M18.442 7.558a.625.625 0 0 1 0 .884l-8 8a.625.625 0 0 1-.884 0l-4-4a.625.625 0 1 1 .884-.884L10 15.116l7.558-7.558a.625.625 0 0 1 .884 0Z", clipRule: "evenodd" }));
export {
  t as default
};
